<template>
    <div>
        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="card-title-style">
                Movimiento Contraloría
            </v-card-title>
            <v-form ref="form" v-model="validForm" lazy-validation>
                <v-card-text>
                    <v-row justify="center" v-if="loaded == false">
                        <v-col cols="12" md="7">
                            <v-skeleton-loader
                                type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"></v-skeleton-loader>
                        </v-col>
                    </v-row>
                    <v-row justify="center" v-if="loaded == true">
                        <v-col cols="12" md="7">
                            <div>
                                <span class="type-label-style">Tipo de Movimiento</span>
                                <p class="type-text-style">Otros</p>
                            </div>
                            <v-divider class="mt-1"></v-divider>

                            <div class="my-5">
                                <span class="type-label-style">Fecha del movimiento:</span>
                                <v-dialog ref="dialog" outlined v-model="modal" :return-value.sync="selectedDate"
                                    persistent width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <div class="date-align-center">
                                            <v-text-field v-model="selectedDate" label="" readonly
                                                :rules="rulestextfechas" outlined dense v-bind="attrs"
                                                v-on="on"></v-text-field>
                                        </div>
                                    </template>
                                    <v-date-picker v-model="selectedDate" locale="es-mx" :max="maxDate" :min="minDate"
                                        scrollable>
                                        <v-spacer></v-spacer>
                                        <v-btn text color="primary" @click="modal = false">
                                            Cancel
                                        </v-btn>
                                        <v-btn text color="primary" @click="$refs.dialog.save(selectedDate)">
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </div>
                            <v-divider v-if="aiclave != 5" class="mt-1"></v-divider>

                            <div v-if="aiclave != 5">
                                <span class="type-label-style">Respuesta:</span>

                                <v-container>
                                    <v-radio-group v-model="radio" row>
                                        <v-radio label="SI" value="S" @click="RadioClick()"></v-radio>
                                        <v-radio label="NO" value="N" @click="RadioClick()"></v-radio>
                                    </v-radio-group>
                                </v-container>
                            </div>

                            <span style="color: red" v-show="validaRadio">Selección requerida</span>

                            <v-divider class="mt-1"></v-divider>

                            <div>
                                <span class="type-label-style">Concepto:</span>

                                <v-select return-object solo :items="movimientosArray" v-model="motivoSelected"
                                    item-text="ceconcepto" item-value="ceclave" placeholder="Seleccione Motivo"
                                    :rules="ruleSelect">
                                </v-select>
                            </div>

                            <v-divider class="mt-1"></v-divider>

                            <v-icon id="publico" class="disable-action" :color="'#4CAF50'" large v-show="tramPublic"
                                @click="cambiarpubpriv()">mdi-lock-open</v-icon>
                            <v-icon id="privado" class="disable-action" :color="'#F44336'" large v-show="tramPrivate"
                                @click="cambiarpubpriv()">mdi-lock</v-icon>

                            <div class="mt-4">
                                <span class="type-label-style">Observaciones:</span>
                                <v-textarea id="textareaobs"
                                    v-on:blur="observacionesSelected = observacionesSelected.trim()"
                                    v-model="observacionesSelected" class="mt-2 textarea" :class="obsClass" outlined
                                    hide-details :rules="rulestextarea" :maxlength="$store.state.maxLengthComentarios">
                                </v-textarea>
                                <v-row>
                                    <v-col>
                                        <span style="color: red">{{ obsError }}</span>
                                    </v-col>
                                    <v-col style="display: grid; place-items: end;">
                                        <span class="v-counter">{{ obsCounter }}/{{ $store.state.maxLengthComentarios
                                            }}</span>
                                    </v-col>

                                </v-row>



                            </div>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <!--<v-btn color="#536DFE" dark v-on:click="saveMovimientoProcess()">Guardar</v-btn>-->

                            <v-btn class="ma-2" color="primary" title="Guardar" @click="saveMovimientoProcess()"
                                :disabled="disBtn">
                                <span style="color: white">Guardar</span>
                            </v-btn>

                            <v-btn color="#FF4081" v-on:click="clearOptions()">
                                <span style="color: white">Limpiar</span>
                            </v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-row>
                </v-card-text>
            </v-form>
        </v-card>
    </div>
</template>
<script>
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
import reporteGeneral from "@/services/ReporteGeneral/ReporteGeneral.service.js";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import moment from "moment";
export default {
    title() {
        return this.$route.meta.title
    },
    data() {
        return {
            validForm: true,
            respuestaText: "SI",
            encabezadoText: [],
            loaded: false,
            motivoSelected: null,
            dateCollabsable: false,
            dateComponentConstraints: {},
            obsError: "",
            campoRequeridoRules: [(v) => !!v || "Campo requerido"],
            obsCounter: "",
            //rulestextarea: [
            //    (v) => {
            //        if (!!v) {
            //            this.obsError = "Campo requerido";
            //        }
            //    },

            //    (v) => {
            //        if (v == null) {
            //            this.obsError = "";
            //            return true;
            //        } else {
            //            if (v.trim().length < 12) {

            //                this.obsError = "Mínimo 12 Carácteres";
            //                return "Mínimo 12 Carácteres";
            //            } else if (v.trim().length > 500) {

            //                this.obsError = "Máximo 500 Carácteres";
            //                return "Máximo 500 Carácteres";
            //            } else return true;
            //        }
            //    },
            //],
            rulestextarea: [
                //v => !!v || 'Campo requerido',
                (v) => {
                    if (v == null || v == "") {
                        return "Campo requerido";
                    } else {
                        if (v.trim().length < 12) {
                            return "Mínimo 12 Carácteres";
                        } else if (v.trim().length > this.$store.state.maxLengthComentarios) {
                            return "Máximo " + this.$store.state.maxLengthComentarios + " Carácteres";
                        } else {
                            return true;
                        }
                    }
                },
            ],

            rulestextfechas: [(v) => !!v || "Campo requerido"],
            ruleSelect: [(v) => !!v || "Campo requerido"],

            dynamicInputsErrorMessage: false,

            dynamicVModels: [],
            dynamicInputVmodels: [],

            extraDataItems: [],
            inputDinamicos: [],

            radio: "",
            selectedDate: "",
            minDate: null,
            maxDate: null,
            observacionesSelected: "",
            aiclave: 0,
            validaRadio: false,
            //Contraloria
            movimientosArray: [],
            esid: 0,
            obsClass: "",
            tramPublic: false,
            tramPrivate: false,
            menu1: false,
            dialog: false,
            modal: false,
            load: false,
            disBtn: false,
            datosReporte: null,
        };
    },
    computed: {
        ...mapState({ drawer: (state) => state.drawer }),
        ...mapState(["domain", "informationPage"]),
        DRAWER_STATE: {
            get() {
                return this.drawer;
            },
        },
    },
    async mounted() {
        this.changeReporteMenuOption("Contraloría");

        let datos = await MetodosGenerales.obtenerSessionReporte("reporte");
        this.datosReporte = datos;


        await this.getDatosGenerales();


        await MetodosGenerales.verificarPermisoSolo(
            this.domain.domainNameForApi,
            "VerificarPermiso",
            "312"
        ).then((response) => {
            if (response.data.length > 0) {
            } else {
                this.$router.push({ name: `NoAutorizado` }).catch((error) => error);
            }
        });

        this.movimientosArray = await reporteGeneral.MovimientosContraloria(
            this,
            this.datosReporte
        );

        if (this.movimientosArray.length == 1) {
            this.motivoSelected = this.movimientosArray[0];
        }

        this.dateCollabsable = true;

        this.aiclave = datos.aiclave;
    },
    methods: {
        ...mapMutations(["changeReporteMenuOption"]),

        dynamicRulesGen(item) {
            var resultRules = [];
            try {
                if (item.required == "SI") {
                    resultRules.push((v) => !!v || "Campo requerido");
                }
                if (item.regex != null) {
                    if (item.idNombre != "tCorreoCopia") {
                        resultRules.push(
                            (v) => new RegExp(item.regex).test(v) || "Inserte un valor valido"
                        );
                    }
                }
            } catch (e) { }
            return resultRules;
        },
        RadioClick() {
            this.validaRadio = false;
        },
        async getDatosGenerales() {
            let today = new Date().toJSON().slice(0, 10);
            this.maxDate = today;
            this.selectedDate = today;
            const d = new Date();

            moment.locale("en");
            let auxMinDate = moment().format("YYYY[-]MM[-]DD");

            let auxDate = moment().subtract(5, "d").format("YYYY[-]MM[-]DD");

            this.dateFormatted = auxDate;

            this.loaded = true;

            let response = await reporteGeneral.fechaSvreporte(this, this.datosReporte);

            this.minDate = response[0]["svfhreporte"];
        },

        clearOptions() {
            this.observacionesSelected = "";
            this.motivoSelected = null;
            this.radio = "";

            let today = new Date().toJSON().slice(0, 10);
            this.selectedDate = today;
        },
        cambiarpubpriv() {
            if (this.motivoSelected.mppclave == 4) {
                this.motivoSelected.mppclave = 3;
            } else {
                this.motivoSelected.mppclave = 4;
            }
        },

        async saveMovimientoProcess() {
            if (
                this.observacionesSelected == null ||
                this.observacionesSelected == ""
            ) {
                this.obsError = "Campo requerido";
            } else {
                if (this.observacionesSelected.trim().length < 12) {
                    this.obsError = "Mínimo 12 Carácteres";
                } else if (this.observacionesSelected.trim().length > this.$store.state.maxLengthComentarios) {
                    this.obsError = "Máximo " + this.$store.state.maxLengthComentarios + " Carácteres";
                }
            }

            let formValidation = this.$refs.form.validate();

            this.disBtn = true;

            if ((this.radio == null || this.radio == "") && this.aiclave != 5) {
                this.validaRadio = true;
            }

            if (!formValidation || this.validaRadio) {
                this.disBtn = false;
                return;
            }

            this.$swal({
                position: "center",
                title: "Cargando...",
                html: "Espere un momento por favor",
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirm: false,
            });
            this.$swal.showLoading();

            try {
                let resp = await reporteGeneral.AgregarMovimientosContraloria(
                    this,
                    this.motivoSelected.ceclave,
                    this.selectedDate,
                    this.radio,
                    this.observacionesSelected,
                    this.esid,
                    this.datosReporte
                );

                setTimeout(() => { }, 1000);

                this.$swal({
                    position: "center",
                    icon: "success",
                    title: "Éxito!",
                    html: "Movimiento realizado correctamente",
                    allowOutsideClick: false,
                    showConfirmButton: true,
                    timer: 3000,
                }).then(async () => {
                    this.asistenciaurl = await MetodosGenerales.ObtenerURL(this.datosReporte);
                    this.$router.push({ path: this.asistenciaurl + '/ReporteDetalle' });
                });
            } catch (e) {
                this.$swal({
                    position: "center",
                    icon: "error",
                    title: "Algo salio mal",
                    html: "Algo salio mal, por favor intente de nuevo mas tarde",
                    allowOutsideClick: false,
                    showConfirmButton: true,
                });
            }
        },
    },
    watch: {
        observacionesSelected(val) {
            if (val != "") {
                this.obsError = "";


            }

            this.obsCounter = this.observacionesSelected.length.toString();
        },
        "motivoSelected.mppclave"(val) {
            if (val != null) {
                this.validatramite = false;
                var privado = document.getElementById("privado");
                var publico = document.getElementById("publico");
                if (val == 2 || val == 4) {
                    if (val == 4) {
                        privado.classList.remove("disable-action");
                        publico.classList.remove("disable-action");
                    }

                    this.tramPublic = false;
                    this.tramPrivate = true;

                    this.esid = 8;
                    this.obsClass = "observaciones-privCon";
                } else if (val == 1 || val == 3) {
                    if (val == 3) {
                        privado.classList.remove("disable-action");
                        publico.classList.remove("disable-action");
                    }

                    this.tramPublic = true;
                    this.tramPrivate = false;
                    this.esid = 7;
                    this.obsClass = "observaciones-pubCon";
                }
            }
        },
    },
};
</script>
<style>
.date-card-title-text {
    margin-top: 1px !important;
    margin-bottom: 1px !important;
    font-family: "Roboto", sans-serif;
    font-weight: 700;
    font-size: 14px;
    color: rgb(59, 59, 59);
}

.calendar-container-style {
    padding: 0px !important;
}

.lockBtn {
    font-size: 40px !important;
}

.obsFieldCon {
    background-image: url("https://www.ausa.com.mx/img/Prusia/privado.png");
    background-repeat: repeat;
}

.observaciones-privCon {
    background-image: url("https://www.ausa.com.mx/img/Prusia/privado.png");
    background-repeat: repeat;
}

.observaciones-pubCon {
    background-image: url("https://www.ausa.com.mx/img/Prusia/publico.png");
    background-repeat: repeat;
}

.addMovimientoClassList .vs-collapse-item--header {
    padding-top: 6px !important;
    padding-bottom: 6px !important;
    background-color: #e0e0e0 !important;
}

.addMovimientoClassList .con-content--item {
    padding: 0px !important;
}
</style>
<style scoped>
.card-title-style {
    background-color: #536dfe;
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    font-size: 1.1em;
    color: white;
}

.textarea {
    resize: none !important;
}

.title-card-style {
    padding: 1.5px !important;
    max-height: auto;
}

.collapsable-container {
    background-color: white;
    height: 100% !important;
}

.type-label-style {
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    font-size: 12px;
}

.type-text-style {
    font-family: "Poppins", sans-serif;
    font-weight: 700;
    font-size: 1.3em;
}

.date-card-title-text {
    margin-top: 1px !important;
    margin-bottom: 1px !important;
    font-family: "Roboto", sans-serif;
    font-weight: 700;
    font-size: 14px;
    color: rgb(59, 59, 59);
}

.calendar-container-style {
    padding: 0px !important;
}

.error-message-style {
    font-family: "Roboto", sans-serif;
    color: red;
    font-weight: 400;
    font-size: 12px;
}
</style>
